// extracted by mini-css-extract-plugin
export default {"container":"EmailShare_container__oSvDm","shareEmailBtn":"EmailShare_shareEmailBtn__A4sfv","emailSvg":"EmailShare_emailSvg__XT11U"};